module.exports = __webpack_public_path__ + "img/pregeles-fempregeles-thumb.5dbe004a.jpg";